export const headerData = [
  // {
  //   type: "checkbox",
  //   text: ""
  // },
  {
    text: "Gift ID",
  },
  {
    text: "Type",
  },
  {
    text: "Title",
  },
  {
    text: "Value / Product ID",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "Try the blue button on the top right and add a few!",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "id",
    type: "",
  },
  {
    key: "type",
    type: "",
  },
  {
    key: "title",
    type: "",
  },
  {
    key: "value",
    type: "",
  },
];

export const PAIYA_GIFT_TYPES = [
  { id: "COINS", value: "VALUE", label: "COINS", type: "number" },
  {
    id: "LUCKY_DRAW",
    value: "PRODUCT ID",
    label: "LUCKY_DRAW",
    type: "string",
  },
  { id: "PRODUCT", value: "PRODUCT", label: "PRODUCT", type: "string" },
];

export const PAIYA_GIFT_TOAST_MESSAGE = "Paiya Gift Created Successfully.";

interface IPlaceholder {
  [key: string]: string;
}
export const TITLE_PLACEHOLDER: IPlaceholder = {
  COINS: "Coins ka discount",
  LUCKY_DRAW: "LUCKYDRAW_Aata Chakki 5kg",
  PRODUCT: "Aata Chakki 5kg",
};
